var LaravelElixirBundle = (function (exports) {
'use strict';

//Create cake link using session data
function cakeLinkify(url,dealWin){
    var brokendomain = url.split('?');
    var querystring = brokendomain[1];
    var parts = querystring.split('&');
    var components = {
        'a':'',
        'c':'',
        's1':''
    };
    for(var i = 0;i < parts.length;i++){
        var part = parts[i].split('=');
        if (part[0] == 'a'){
            components.a = part[1];
        } else if (part[0] == 'c') {
            components.c = part[1];
        } else if (part[0] == 's1') {
            components.s1 = part[1];
        }

    }
    //If cake link is malformed, open original link, otherweise build link and continue
    if(isNaN(components.c)){
        dealWin.location.href = url;
    } else {
        axios.get('/get-session')
            .then(function (response) {

                var newurl = brokendomain[0];

                //Check and replace affid
                if(response.data.utm_campaign){
                    newurl = newurl + '?a=' + response.data.utm_campaign;
                }
                else {
                    newurl = newurl + '?a=438';
                }

                newurl = newurl + '&c=' + components.c;

                //check and replace s1
                if(response.data.s1 && response.data.s1 != 'default'){
                    newurl = newurl + '&s1=' + response.data.s1;
                }
                else {
                    newurl = newurl + '&s1=';
                }

                //check and replace s2
                if(response.data.s2 && response.data.s2 != 'default'){
                    newurl = newurl + '&s2=' + response.data.s2;
                }

                //check and replace s3
                if(response.data.s3 && response.data.s3 != 'default'){
                    newurl = newurl + '&s3=' + response.data.s3;
                }

                //check and replace s4 with keyword id
                if(response.data.kid && response.data.kid != 'default'){
                    newurl = newurl + '&s4=' + response.data.kid;
                }

                //check and replace s5 with gcid
                if(response.data.gcid && response.data.gcid != 'default'){
                    newurl = newurl + '&s5=' + response.data.gcid;
                }

                dealWin.location.href = newurl;
            })
            .catch(function (error) {
              console.log(error);
              dealWin.location.href = url;
          });
    }
}

$(document).ready(function(){
    $('.dealbutton').on('click',function(e){
        e.preventDefault();
        var dealWindow = window.open('/loading', '_blank');

        var link = $(this).attr("href");
        var cakelink = $(this).next().val();

        var brand = $(this).prev().val();
        TagManager.fireEvent('dealbuttonclick' , {"cardbrand":brand});

        if (cakelink == 'isCake'){
            cakeLinkify(link,dealWindow);
        } else {
            console.log('not cake');
            dealWindow.location.href = link;
        }

    });
});

return exports;

}({}));
//# sourceMappingURL=offer-clickB.js.map
